import { F18_SERVICES } from '../configs/Config'
import { apiCMSWithToken } from './axios'

export const url = {
  dashboard: `/report`
}

export async function countDashBoard(filters = {}) {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(`${url.dashboard}/dash-board/count?${params}`)
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}
export async function reportOperational(filters = {}) {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(`${url.dashboard}/operational_reports?${params}`)
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

// export async function footerAdd(body) {
//   const response = await apiCMSWithToken.post(`${url.footer}`, body)
//   return response
// }
// export async function footerPosition(body) {
//   const response = await apiCMSWithToken.post(`${url.footer}/position`, body)
//   return response
// }

// export async function footerDelete(id) {
//   try {
//     const response = await apiCMSWithToken.delete(`${url.footer}/${id}`)
//     return response
//   } catch (error) {
//     console.error('Error in postSearch:', error)
//     throw error
//   }
// }

// export async function footerActive(body) {
//   const response = await apiCMSWithToken.post(`${url.footer}/active-area`, body)
//   return response
// }

export default {
  countDashBoard,
  reportOperational
  // footerAdd,
  // footerPosition,
  // footerDelete,
  // footerActive
}
